module.exports = __webpack_public_path__ + "static/media/button.0b5e868f.png";